import { render, staticRenderFns } from "./ProfileContent.vue?vue&type=template&id=4f2de920&scoped=true"
import script from "./ProfileContent.vue?vue&type=script&lang=js"
export * from "./ProfileContent.vue?vue&type=script&lang=js"
import style0 from "./ProfileContent.vue?vue&type=style&index=0&id=4f2de920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2de920",
  null
  
)

export default component.exports